var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 502,
    height: 482,
    viewBox: "0 0 502 482",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M479.412 153.249L282.292 10.1016C263.403 -3.13739 238.248 -3.13739 219.359 10.1016L22.2389 153.249C3.37293 166.849 -4.55807 191.072 2.61193 213.196L77.9189 444.876C85.0519 467.007 105.653 482.006 128.906 481.996H372.533C395.785 482.006 416.386 467.007 423.52 444.876L498.827 213.196C506.041 191.117 498.2 166.905 479.412 153.249Z",
    fill: "#E1E1E1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonIcon);
export default __webpack_public_path__ + "static/media/polygonIcon.3dcd34401f5e0de601a502448800d6e5.svg";
export { ForwardRef as ReactComponent };